module.exports = __webpack_public_path__ + "static/img/cardlist.8dcd8a3f.png";